import type { KronaFilterOpts, KronaTraitFilterOpts } from './Types.ts'
import { taxaPathKey } from 'Util/Visualisation/TaxaPathKey.ts'

export const kronaOptsKey = (o: KronaFilterOpts) =>
  `v1|p=${taxaPathKey(o.selectedPath)}|g=${o.gradeThreshold}|sc=${o.scalingMode}`

export const kronaTraitOptsKey = (o: KronaTraitFilterOpts) =>
  `v1|p=${taxaPathKey(o.selectedPath)}|g=${o.gradeThreshold}|tg=${o.traitGroup}|sc=${o.scalingMode}|tm=${o.noTraitMode}`
